export const sixEndpoints = {
  getSixes: '/private/v1/sixes',
  createSixModalInfo: '/private/v1/create-six-modal-information',
  validateSixName: '/private/v1/sixes/validate-name',
  createSix: '/private/v1/sixes',
  updateSix: (id: string) => `/private/v1/sixes/${id}`,
  searchSixes: '/private/v1/sixes/search',
  getSix: (id: string) => `/private/v1/sixes/${id}`,
  getSixActivity: (id: string) => `/private/v1/sixes/${id}/activity`,
  getSixFiles: (id: string) => `/private/v1/sixes/${id}/files`,
  getSixParticipants: (id: string) => `/private/v1/sixes/${id}/participants`,
  searchSix: (id: string) => `/private/v1/sixes/${id}/search`,
  exportSix: (id: string) => `/private/v1/sixes/${id}/export`,
  uploadSixFiles: (id: string) => `/private/v1/sixes/${id}/files`,
  createSixFolder: (id: string) => `/private/v1/sixes/${id}/folders`,
  markFileDownloaded: (sixId: string, fileId: string) =>
    `/private/v1/sixes/${sixId}/file/${fileId}/downloaded`,
  deleteSix: (id: string) => `/private/v1/sixes/${id}`,
  deleteFile: (sixId: string, fileId: string) => `/private/v1/sixes/${sixId}/file/${fileId}`,
  deleteFolder: (sixId: string) => `/private/v1/sixes/${sixId}/folders`,
  getMissingFileKeys: '/private/v1/sixes/missing-file-keys',
} as const;

export type SixEndpointKey = keyof typeof sixEndpoints;
